import * as types from 'features/EventContainer/redux/types/ExportScheduleType';
import formatSchedulePayload from 'features/EventContainer/utils/formatSchedulePayload';
import { roomTeamAssignmentPayload,tableTeamAssignmentPayload } from 'features/EventContainer/utils/formatTeamAssignmentPayload';
import { notification } from 'antd';
import { API } from 'utils/api';
import * as panelService from 'utils/services/panels';
import { JUDGING_REVIEW_PANEL_TYPE_ID,REFEREE_REVIEW_PANEL_TYPE_ID } from 'shared/constants/panelTypes';
import { checkDateInEventDates, formatTime24and12Time,formatDateTimeToTimezone, parseDate, checkStartTimeBeforeEndTime, validateDate,validateTeamSessionsStartTime,validateTeamSessionsEndTime } from 'utils/dateTimeUtils';
import { getPanelsData } from 'utils/services/sessions';
import { handleJudgingPanelDataSuccess, handlePanelDataSuccess } from './scheduleActions/scheduleDetails';
import { IN_PERSON_OFFICIAL, IN_PERSON_TEST, REMOTE_OFFICIAL, REMOTE_TEST } from 'shared/constants/eventTypes';
import { OPEN_CEREMONY,CLOSE_CEREMONY, JUDGE_SESSION, MATCH, CEREMONY, OPEN, CLOSE, PRACTICE_MATCH, OFFICIAL_MATCH, OFFICIAL_MATCH_1, OFFICIAL_MATCH_2, OFFICIAL_MATCH_3 } from 'shared/constants/scheduleType';


export const setExportEventDetail = (eventDetail) => {
  return {
    type: types.SET_EVENT_DETAIL,
    payload: {
      eventDetail,
    }
  }
}
export const clearExportEventSchedule = () => {
  return {
    type: types.SET_CLEAR_ALL_SESSION,
   
  }
}
export const clearExportJudgingSession = () => {
  return {
    type: types.SET_CLEAR_JUDGING_SESSION,
   
  }
}
export const clearExportMatchesSession = () => {
  return {
    type: types.SET_CLEAR_MATCHES_SESSION,
   
  }
}
export const setExportEventCeremony = (Ceremony) => {
  return {
    type: types.SET_EVENT_CEREMONY,
    payload: {
      Ceremony,
    }
  }
}

export const setExportJudgingSession = (judgingSession) => {
  return {
    type: types.SET_JUDGING_SESSION,
    payload: {
      judgingSession,
    }
  }
}

export const setExportMatcheSession = (matchesSession) => {
  return {
    type: types.SET_MATCHES_SESSION,
    payload: {
      matchesSession,
    }
  }
}

const schedulerBegin = () => ({
  type: types.SCHEDULE_BEGIN,

})
const schedulerError = () => ({
  type: types.SCHEDULE_BEGIN_ERROR,
 
})
const schedulerSuccess = () => ({
  type: types.SCHEDULE_BEGIN_SUCCESS,
 
})


export const setImportSchedule = (schedule) => {
  return {
    type: types.SET_IMPORT_SCHEDULE,
    payload: {
      addScheduleImportList: schedule
    }
  }
}

export const setInvitedScheduleSession = (successfullyInvited, notInvited) => {
  return {
    type: types.SET_EVENT_SCHEDULE_INVITED,
    payload: {
      successfullyInvited:successfullyInvited, 
      notInvited:notInvited
    }
  }
}
export const setCountNewJudgingPanel = (countNewJudgingPanel) => {
  return {
    type: types.SET_COUNT_NEW_JUDGING_PANEL,
    payload: {  
      countNewJudgingPanel
    }
  }
}

export const setCountNewMatchesPanel = (countNewMatchesPanel) => {
  return {  
    type: types.SET_COUNT_NEW_MATCHES_PANEL,
    payload: {
      countNewMatchesPanel
    }
  }
}

export const handleResetImportScheduleModal = () => {
  return {
    type: types.RESET_IMPORT_SCHEDULE_MODAL,
   
  }
}

// Import schedule actions

export const handleSetCountNewJudgingPanel= (countNewJudgingPanel) => {
  return async dispatch => {  
    await dispatch(setCountNewJudgingPanel(countNewJudgingPanel))
  }
}

export const handleSetCountNewMatchesPanel= (countNewMatchesPanel) => {
  return async dispatch => {
    await dispatch(setCountNewMatchesPanel(countNewMatchesPanel))
  }
}

export const handleSchedulerBegin = () => {
  return async dispatch => {
    await dispatch(schedulerBegin())
  }
}

export const handleSchedulerError = () => {
  return async dispatch => {
    await dispatch(schedulerError())
  }
}

export const handleSchedulerSuccess = () => {
  return async dispatch => {
    await dispatch(schedulerSuccess())
  }
}

export const handleImportSchedule = (schedule) => {
  return async dispatch => {
    try {
      await dispatch(setImportSchedule(schedule))
    } catch (err) {
      throw err
    }
  }
}


const inviteImportedAllSession = async (invitedSchedule, time_zone, sessionSuccessInvited, sessionNotInvited) => {
 
  const Sessions = invitedSchedule.filter(session =>   
    session.isSessionChanged === true 
  );

  if (Sessions.length === 0) return Sessions;

  const uploadedSessions = Sessions.map((schedule) => {
    const formattedZuluStart = formatDateTimeToTimezone(schedule.date, schedule.startTime, time_zone);
    const formattedZuluEnd = formatDateTimeToTimezone(schedule.date, schedule.endTime, time_zone);

    const formValues = {
      startTime: formattedZuluStart,
      endTime: formattedZuluEnd,
    };
    const payload = formatSchedulePayload(schedule, formValues);

    return {
      schedule,
      payload
    };
  });

    var updatedPayload={data:[]};
    for (let i = 0; i < uploadedSessions.length; i++) {
      const {payload}=uploadedSessions[i];
      updatedPayload.data.push(payload);
    }

      try {

         let response={};
          try
          {
            response = await API.GetInstance().http.patch(`/api/sessions`, updatedPayload);
          }catch (err) {
          response=err.data;
          }
        const { data }=response;

        for (let i = 0; i < uploadedSessions.length; i++) {
        const {schedule}=uploadedSessions[i]; 
        const { id,type,errors } = schedule;
        const newSession= data.find(sn => sn.sessionId===id & sn.sessionType===type);
        if(newSession) {
          if(!newSession.error) {
            sessionSuccessInvited.push(schedule);
          }
          else
          {         
            errors.push({ message: `${type} : ${newSession.error}` });
            sessionNotInvited.push({
              ...schedule,
              errors
            });
          }
        }
      }
     
    }catch (err) {
      notification.error({
        message: 'Error',
        description: `Error in saving sessions.`,
      });
     throw err;
    }
};


export const handleInviteScheduleList = (cb = () => {}) => {
  return async (dispatch, getState) => {
    const {
      event: { eportEventSchedule, eventDetails }
    } = getState();
    
    const { time_zone } = eventDetails;
    const { addScheduleImportList,csvScheduleImport } = eportEventSchedule;
    const {successfullyInvited, notInvited} = csvScheduleImport;

    const sessionSuccessInvited = [];
    const sessionNotInvited = [];

    try {
   
      await dispatch(handleSchedulerBegin());

      await inviteImportedAllSession(addScheduleImportList, time_zone, sessionSuccessInvited, sessionNotInvited);

     // Merge and skip duplicates by id
      const mergedSuccessInvited = [
        ...sessionSuccessInvited,
        ...successfullyInvited.filter(
          item2 => !sessionSuccessInvited.some(item1 => item1.id === item2.id)
        )
      ];
      const mergedNotInvite = [
        ...sessionNotInvited,
        ...notInvited.filter(
          item2 => !sessionNotInvited.some(item1 => item1.id === item2.id)
        )
      ];

      await dispatch(setInvitedScheduleSession(mergedSuccessInvited, mergedNotInvite));

      if(mergedNotInvite.length<=0) {
        notification.success({
          message: 'Success',
          description: mergedSuccessInvited.length > 1 ? 'Sessions were successfully saved!' : 'Session was successfully saved!'
        });
      }
      
      await dispatch(handleSchedulerSuccess());
      cb();
    } catch (err) {
      await dispatch(handleSchedulerError());
    }
  };
};

const createNewJudgingPanel = async (eventScheduleId,countNewJudgingPanel) => {

  const { panelNames, count } = countNewJudgingPanel;
 
  try {
    let data = {
      panel_type_id:JUDGING_REVIEW_PANEL_TYPE_ID,
      desired_number_of_panels:count,
      panel_names:panelNames,
      schedule_id: eventScheduleId
    }
     await panelService.batchCreatePanel(data);
    notification.success({
      message: 'Success',
      description: count > 1 ? 'Rooms were successfully created.' : 'Room was successfully created.',
    }); 
  } catch (err) {
    if(err?.data?.statusCode == 400 && err?.data?.error == 'Failed to add new panels as current request would result in a panel count higher than allowable threshold of 64.'){
      notification.error({
        message: 'Error',
        description: 'A maximum of 64 rooms/tables can be created',
      });
    }else{
      notification.error({
        message: 'Error',
        description: 'Error in creating rooms',
      });
    }
    throw err;
  }

}

const createNewScoringPanel = async (eventScheduleId,countNewMatchesPanel) => {

  const { panelNames, count } = countNewMatchesPanel;

    try {
      let data = {
        panel_type_id:REFEREE_REVIEW_PANEL_TYPE_ID,
        desired_number_of_panels:count,
        panel_names:panelNames,
        schedule_id: eventScheduleId
      }
    
       await panelService.batchCreatePanel(data);

      notification.success({
        message: 'Success',
        description: count > 1 ? 'Tables were successfully created.' : 'Table was successfully created.'
      }); 

    } catch (err) {
      if(err?.status == 400 && err?.data == 'Please provide a number >= 1 and <= 64 for desired number of panels to create.'){
        notification.error({
          message: 'Error',
          description: 'A maximum of 64 rooms/tables can be created',
        });
      }else{
        notification.error({
          message: 'Error',
          description: 'Error in creating the tables',
        });
      }
      throw err;
    }
 
}

const inviteAllTeamAssignment = async (invitedSchedule, scheduleSuccessInvited, scheduleNotInvited) => {
  const Sessions = invitedSchedule.filter(session =>   
    session.isPanelDetailChanged === true 
  );

  if (Sessions.length === 0) return Sessions;

  const teamAssignments = Sessions.map((schedule) => {

     let payload={};
     const type=schedule.type.trim().toLowerCase();
     if(type===JUDGE_SESSION.trim().toLowerCase()) {
       payload = roomTeamAssignmentPayload(schedule);
     }
     else if(type.includes(MATCH)) {
      payload = tableTeamAssignmentPayload(schedule);
     }
    
    return {
      schedule,
      payload
    };
  });

   var updatedPayload={data:[]};
    for (let i = 0; i < teamAssignments.length; i++) {
       const {payload}  = teamAssignments[i];  
      updatedPayload.data.push(payload);
    }
    
    try {

         let response={};
          try
          {
            response=  await panelService.updateAllPanel(updatedPayload);
          }catch (err) {
          response=err.data;
          }
        const { data }=response;

        for (let i = 0; i < teamAssignments.length; i++) {
         const {schedule}  = teamAssignments[i];
         const { id,type,errors } = schedule;

        const newSession= data.find(sn => sn.sessionId===id & sn.sessionType===type);
        if(newSession) {
          if(!newSession.error) {
            scheduleSuccessInvited.push(schedule);
          }
          else
          {         
            errors.push({ message: `${type} : ${newSession.error}` });
            scheduleNotInvited.push({
              ...schedule,
              errors
            });
          }
        }
      }
     
    }catch (err) {
      notification.error({
        message: 'Error',
        description: `Error in assigning teams.`,
      });
     throw err;
    }
};

export const handleInvitePanelList = (cb = () => {}) => {
  return async (dispatch, getState) => {
    const {
      event: { eportEventSchedule, eventDetails }
    } = getState();
    
    const { eventScheduleId } = eventDetails;
    const { countNewJudgingPanel,countNewMatchesPanel } = eportEventSchedule;

    try {
      await dispatch(handleSchedulerBegin());
      if(countNewJudgingPanel.count>0)
      {
        await createNewJudgingPanel(eventScheduleId,countNewJudgingPanel);
        let judgePanelData = await getPanelsData(eventScheduleId, 'judge');
        dispatch(handleJudgingPanelDataSuccess(judgePanelData));
      }

      if(countNewMatchesPanel.count>0)
        {
          await createNewScoringPanel(eventScheduleId,countNewMatchesPanel);
          let scorePanelData = await getPanelsData(eventScheduleId, 'score');
          dispatch(handlePanelDataSuccess(scorePanelData));
        }
 
      cb();
    } catch (err) {
      await dispatch(handleSchedulerError());
    }
  };
};

export const handleTeamsAssignment = (cb = () => {}) => {
  return async (dispatch, getState) => {
    const {
      event: { eportEventSchedule }
    } = getState();
    
    const { addScheduleImportList } = eportEventSchedule;
    const scheduleSuccessInvited = [];
    const scheduleNotInvited = [];

    try {
      await dispatch(handleSchedulerBegin());

      await inviteAllTeamAssignment(addScheduleImportList, scheduleSuccessInvited, scheduleNotInvited);
       
      if(scheduleNotInvited.length<=0) {
        notification.success({
          message: 'Success',
          description: scheduleSuccessInvited.length > 1 ? 'Teams were successfully assigned' : 'Team was successfully assigned'
        });
      }
      else{
          notification.error({
                message: 'Error',
                description: `All teams were not successfully assigned`,
              });
      }

      await dispatch(setInvitedScheduleSession(scheduleSuccessInvited, scheduleNotInvited));
      cb();
    } catch (err) {
       await dispatch(handleSchedulerError());
    }
  };
};

export const handlePanelTeamAssignment = (schedule,assignedSchedule = () => {}) => {

  return async (dispatch, getState) => {
    const {auth: { userInfo: { use_24_hour_format } }, event: {eportEventSchedule,eventSchedule}} = getState();
    const {eventCereMony,judgingSession,matchesSession} = eportEventSchedule;
    const {sessions:{scoringPanelData,judgingPanelData}} = eventSchedule;   
    const{openCeremony,closeCeremony}=eventCereMony;
    

    const type=schedule.type.trim().toLowerCase();
   
    schedule.date= validateDate(schedule.date);
    schedule.startTime= formatTime24and12Time(schedule.startTime,use_24_hour_format);
    schedule.endTime= formatTime24and12Time(schedule.endTime,use_24_hour_format);
    
    if(type===OPEN_CEREMONY.trim().toLowerCase()) {

      if(schedule.date===openCeremony.date &&
        schedule.startTime===openCeremony.start_time &&
        schedule.endTime===openCeremony.end_time) {
        schedule.isSessionChanged=false;
      }     
      
    }
    if(type===CLOSE_CEREMONY.trim().toLowerCase()) {
      if(schedule.date===closeCeremony.date &&
        schedule.startTime===closeCeremony.start_time && 
        schedule.endTime===closeCeremony.end_time) {
        schedule.isSessionChanged=false;
      }
    }

    if(type===JUDGE_SESSION.trim().toLowerCase()){
      const panelName=schedule.panelName.trim();
      const teamNumber=schedule.teamNumber.toString().trim();
      const teamName=schedule.teamName.trim().toLowerCase();

      const panelSession = getPanel(judgingPanelData, panelName);
  
      if(panelSession) {
        schedule.panelId=panelSession.id;
        schedule.panelName=panelSession.name;
      }

      //check for all panel details
      const sessionResult= ValidateAssignPanel(judgingSession,type,panelName,teamNumber,teamName);

      if(sessionResult.completeMatch) {
        //no panel name changed and also no assigned teams changed
        const newSession=sessionResult.completeMatch;
        schedule.id=newSession.id;
        schedule.panelId=newSession.panelId;
        schedule.scheduleId=newSession.scheduleId;
        schedule.isPanelDetailChanged=false;

        if(schedule.date===newSession.date &&
          schedule.startTime===newSession.start_time && 
          schedule.endTime===newSession.end_time) {
          schedule.isSessionChanged=false;
        }
      }
      else if(sessionResult.partialMatch) {
        //update panel if changed to another exisiting panel
        const newSession=sessionResult.partialMatch;
        schedule.id=newSession.id;
        schedule.scheduleId=newSession.scheduleId;

        if(schedule.date===newSession.date &&
          schedule.startTime===newSession.start_time && 
          schedule.endTime===newSession.end_time) {
          schedule.isSessionChanged=false;
        }
      }

    }
    else if(type.includes(MATCH)) {

      const panelName=schedule.panelName.trim();
      const teamNumber=schedule.teamNumber.toString().trim();
      const teamName=schedule.teamName.trim().toLowerCase();

      const panelSession = getPanel(scoringPanelData, panelName);
  
      if(panelSession) {
        schedule.panelId=panelSession.id;
        schedule.panelName=panelSession.name;
      }

      //check for all panel details
      const sessionResult= ValidateAssignPanel(matchesSession,type,panelName,teamNumber,teamName);

      if(sessionResult.completeMatch) {
        //no panel name changed and also no assigned teams changed
        const newSession=sessionResult.completeMatch;
        schedule.id=newSession.id;
        schedule.panelId=newSession.panelId;
        schedule.scheduleId=newSession.scheduleId;
        schedule.isPanelDetailChanged=false;

        if(schedule.date===newSession.date &&
          schedule.startTime===newSession.start_time && 
          schedule.endTime===newSession.end_time) {
          schedule.isSessionChanged=false;
        }
      }
      else if(sessionResult.partialMatch) {
        //update panel if changed to another exisiting panel
        const newSession=sessionResult.partialMatch;
        schedule.id=newSession.id;
        schedule.scheduleId=newSession.scheduleId;

        if(schedule.date===newSession.date &&
          schedule.startTime===newSession.start_time && 
          schedule.endTime===newSession.end_time) {
          schedule.isSessionChanged=false;
        }
      }
    }

    assignedSchedule(schedule);
  }
}

export const handleOverlapTeamSession= (langHook, prevSession, newSession, ErrorCB = () => {}) => {
  return async (dispatch, getState) => {
      const { event: { eventDetails}} = getState();
      const { time_zone  } = eventDetails;
      let Errors = []; 

      if (validateTeamSessionsStartTime(prevSession, newSession, time_zone)) {
              Errors.push({message: langHook('schedulerTeamConflictStartTimeError', { '0': newSession.teamName,'1': `${newSession.newId+1},D`, '2': newSession.startTime, '3': prevSession.startTime, '4': prevSession.endTime,'5':prevSession.type,'6':prevSession.newId+1 })});
            }
      
        if (validateTeamSessionsEndTime(prevSession, newSession, time_zone)) {
              Errors.push({message: langHook('schedulerTeamConflictEndTimeError', { '0': newSession.teamName,'1': `${newSession.newId+1},E`, '2': newSession.endTime, '3': prevSession.startTime, '4': prevSession.endTime,'5':prevSession.type,'6':prevSession.newId+1 })});
        }

      if(Errors.length>0){
          ErrorCB(Errors);
          return;
        }
    }
}

export const handleValidateSchedule = (langHook, schedule, line = 1,ErrorCB = () => {},updatedSchedule = () => {}) => {
  return async (dispatch, getState) => {
    const {auth: { userInfo: { use_24_hour_format } }, event: {eportEventSchedule, eventDetails,eventSchedule}} = getState();
    const { time_zone, attributes } = eventDetails;
    try {
      
        // need session id,panelid to map data correctly

        schedule.eventType = attributes.event_type;
        updateScheduleData(schedule,eportEventSchedule,eventSchedule,dispatch);

        updatedSchedule(schedule);
          
       let totalErrors = [];

       // updating order sequence
        if(totalErrors.length<=0)
        totalErrors.push(...ValidateEventName(langHook, schedule.eventName, line, eportEventSchedule));

        if(totalErrors.length<=0)
        totalErrors.push(...ValidateTypeName(langHook, schedule, line));

       if(totalErrors.length<=0)
        totalErrors.push(...checkRequiredFields(langHook, schedule, line));

        if(totalErrors.length<=0)
        totalErrors.push(...checkDateValidity(langHook, schedule.date, line, eportEventSchedule,time_zone));

        if(totalErrors.length<=0)
        totalErrors.push(...checkTimeValidity(langHook, schedule.startTime, schedule.endTime, line,time_zone,use_24_hour_format));

        if(totalErrors.length<=0)
        totalErrors.push(...ValidateTeamNameWithNumber(langHook, schedule, line, eportEventSchedule));

      if(totalErrors.length>0){
        ErrorCB(totalErrors);
        return;
      }

    } catch(err) {

      throw err;
    }
  }
}

function updateScheduleData(schedule,eportEventSchedule,eventSchedule,dispatch) {
  
  const {eventCereMony,countNewJudgingPanel,countNewMatchesPanel} = eportEventSchedule;
  const {sessions:{scoringPanelData,judgingPanelData}} = eventSchedule;
  const{openCeremony,closeCeremony}=eventCereMony;

  const type=schedule.type.trim().toLowerCase();
  const panelName=schedule.panelName.trim();
 
  if(type===OPEN_CEREMONY.trim().toLowerCase()) {
    schedule.id=openCeremony.id;
    schedule.scheduleId=openCeremony.scheduleId;
    schedule.isPanelDetailChanged=false;
    schedule.isNewPanelAdded=false;
  }
  if(type===CLOSE_CEREMONY.trim().toLowerCase()) {
    schedule.id=closeCeremony.id;
    schedule.scheduleId=closeCeremony.scheduleId;
    schedule.isPanelDetailChanged=false;
    schedule.isNewPanelAdded=false;
  }

  if(type===JUDGE_SESSION.trim().toLowerCase()) {
    //find panel in panellist
    //avoid to create new panel if already exists
    const panelSession = getPanel(judgingPanelData, panelName);

    if(panelSession) {
      schedule.panelId=panelSession.id;
      schedule.panelName=panelSession.name;
      schedule.isNewPanelAdded=false;
    }   
    
    if(schedule.isNewPanelAdded){
        if (!countNewJudgingPanel.panelNames.includes(panelName)) {
            countNewJudgingPanel.panelNames.push(panelName);
            countNewJudgingPanel.count = countNewJudgingPanel.count + 1;
            dispatch(handleSetCountNewJudgingPanel(countNewJudgingPanel));
          }
    }
  }

  if(type.includes(MATCH)) {
    //find panel in panellist
    //avoid to create new panel if already exists
    const panelSession = getPanel(scoringPanelData, panelName);
    if(panelSession) {
      schedule.panelId=panelSession.id;
      schedule.panelName=panelSession.name;
      schedule.isNewPanelAdded=false;
    }  

    if(schedule.isNewPanelAdded){
      if (!countNewMatchesPanel.panelNames.includes(panelName)) {
            countNewMatchesPanel.panelNames.push(panelName);
            countNewMatchesPanel.count = countNewMatchesPanel.count + 1;
            dispatch(handleSetCountNewMatchesPanel(countNewMatchesPanel));
          }   
    }  
  }

  return schedule;
}

function ValidateAssignPanel(sessiondata,nType, panelName,teamNumber,teamName) {
  const sessionResult={partialMatch: {}, completeMatch: {}};

  sessionResult.partialMatch= sessiondata.find(session =>
    session.type.trim().toLowerCase() === nType &&
    session.teamNumber?.toString().trim() === teamNumber &&
    session.teamName?.trim().toLowerCase() === teamName
  );

  sessionResult.completeMatch= sessiondata.find(session =>
    session.panelName?.trim().toLowerCase() === panelName.toLowerCase() &&
    session.type.trim().toLowerCase() === nType &&
    session.teamNumber?.toString().trim() === teamNumber &&
    session.teamName?.trim().toLowerCase() === teamName
  );

  return sessionResult;
}

function getPanel(paneData, panelName) {
   const panelSession= paneData.find(session => session.name?.trim().toLowerCase() === panelName.toLowerCase() );
   
    return panelSession;
}

//partial match for ceremony types
function searchCeremonyType(type) {
  return type.includes('open') || type.includes('clos') || type.includes('cerem');
}

//partial match for judging types
function searchJudgingType(type) {
  return type.includes('jud') || type.includes('sess');
}

//partial match for match types
function searchMatchType(type) {
  return type.includes('prac') || type.includes('match') || type.includes('off');
}

export const checkRequiredFields = (langHook, schedule, line) => {
  const errorsArray = [];
 const type= schedule.type.trim().toLowerCase();
  if(!schedule.eventName.trim() && errorsArray.length <=0) {
    errorsArray.push({message: langHook('schedulerEventNameMissingErrorLabel', { '0': `${line},A` })});
  }
  if(!type  && errorsArray.length <=0) {
   errorsArray.push({message: langHook('schedulerTypeMissingErrorLabel', { '0': `${line},B` })});
  }
  if(!schedule.date && errorsArray.length <=0) {
    errorsArray.push({message: langHook('schedulerDateMissingErrorLabel', { '0': `${line},C` })});
  }
  if(!schedule.startTime && errorsArray.length <=0) {
     errorsArray.push({message: langHook('schedulerStartTimeMissingErrorLabel', { '0': `${line},D` })});
  }
  if(!schedule.endTime && errorsArray.length <=0) {
     errorsArray.push({message: langHook('schedulerEndTimeMissingErrorLabel', { '0': `${line},E` })});
    }


  if(!schedule.panelName.trim() && errorsArray.length <=0  && type && !searchCeremonyType(type)) {
    if(searchJudgingType(type)) {
      errorsArray.push({message: langHook('schedulerRoomMissingErrorLabel', { '0': `${line},F` })});
    }
    else if(searchMatchType(type))
    {
      errorsArray.push({message: langHook('schedulerTableMissingErrorLabel', { '0': `${line},F` })});
    }
  }

  if(!schedule.teamNumber && errorsArray.length <=0 && type && !searchCeremonyType(type)) {
    if(searchJudgingType(type) || searchMatchType(type)) {
      errorsArray.push({message: langHook('schedulerTeamNumberMissingErrorLabel', { '0': `${line},G` })});
    }   
  }

  if(!schedule.teamName && errorsArray.length <=0 && type && !searchCeremonyType(type)) {
     if(searchJudgingType(type) || searchMatchType(type)) {
       errorsArray.push({message: langHook('schedulerTeamNameMissingErrorLabel', { '0': `${line},H` })});
    }     
  }

  return errorsArray;
  
}

export const ValidateEventName = (langHook, evtName, line, eportEventSchedule) => {
  const errorsArray = [];
  const {eventDetail} = eportEventSchedule;
  const{eventName,}=eventDetail;
  evtName=evtName.trim().toLowerCase();

  if(evtName) {
    if(evtName!=eventName.trim().toLowerCase()) {
       errorsArray.push({message: langHook('schedulerInvalidEventNameErrorLabel', { '0': `${line},A` })});
    }
   
  }
  
  return errorsArray;
  
}


function hasTeamNumberFind(data, teamNumber) {
  return !!data.find(session => session.teamNumber === teamNumber);
}
function hasTeamNameFind(data, teamName) {
  return !!data.find(session => session.teamName.trim().toLowerCase() === teamName);
}
function hasTeamNameAndNumberFind(data, teamName, teamNumber) {
  return !!data.find(session => session.teamName.trim().toLowerCase() === teamName && session.teamNumber === teamNumber);
}

export const ValidateTypeName = (langHook, schedule, line) => {
  const errorsArray = [];

  const searchType= schedule.type.trim().toLowerCase();
  if(searchType) {
    if(searchType!=OPEN_CEREMONY.trim().toLowerCase()) {
      if(searchType!=CLOSE_CEREMONY.trim().toLowerCase()) {
        if(searchType!=JUDGE_SESSION.trim().toLowerCase()){
           if(searchType!=PRACTICE_MATCH.toLowerCase()){ 
              if(searchType!=OFFICIAL_MATCH.toLowerCase() || (schedule.eventType === IN_PERSON_OFFICIAL ||schedule.eventType === IN_PERSON_TEST))
              {
                if((searchType!=OFFICIAL_MATCH_1.toLowerCase() && searchType!=OFFICIAL_MATCH_2.toLowerCase() && searchType!=OFFICIAL_MATCH_3.toLowerCase()) ||
                   (schedule.eventType === REMOTE_OFFICIAL ||schedule.eventType === REMOTE_TEST)) 
                  {
                    if(!schedule.panelName && !schedule.teamNumber && !schedule.teamName) {
                      // error for ceremony type
                          errorsArray.push({message: langHook('schedulerInvalidTypeErrorLabel', { '0': `${line},B` })});
                      }
                      else
                      {
                        //searching with 'off' text for official match
                        if(searchType.includes("off")){
                          // Extract the last "word" (after the last space)
                              const lastPart = searchType.trim().split(" ").pop();
                              const hasNonDigit = /\D/.test(lastPart);
                              const numbers = searchType.match(/\d+/g);
                              const number = numbers ? parseInt(numbers[0]) : 0;
                          // error for match
                          if(schedule.eventType === IN_PERSON_OFFICIAL || schedule.eventType === IN_PERSON_TEST) {
                            if(!hasNonDigit && number<=3 && number>0){
                                errorsArray.push({message: langHook('schedulerInvalidTypeSpecificInPersonErrorLabel', { '0': `${line},B` })});
                            }
                            else{
                             errorsArray.push({message: langHook('schedulerInvalidTypeErrorLabel', { '0': `${line},B` })});
                            }
                              
                          }
                          else if(schedule.eventType === REMOTE_OFFICIAL || schedule.eventType === REMOTE_TEST) {
                            
                            if(!hasNonDigit && number<=3 && number>0){
                                 errorsArray.push({message: langHook('schedulerInvalidTypeErrorLabel', { '0': `${line},B` })});
                              }
                              else{
                                 errorsArray.push({message: langHook('schedulerInvalidTypeSpecificRemoteErrorLabel', { '0': `${line},B` })});
                              }  
                          }

                        }
                        else{
                          // error for judging and practice
                          errorsArray.push({message: langHook('schedulerInvalidTypeErrorLabel', { '0': `${line},B` })});
                        }
                        
                      } 

                  }
              }
             
          }
        }
    }
  }
}
  return errorsArray;

}

export const checkDateValidity = (langHook, date, line, eportEventSchedule,time_zone) => {
  const errorsArray = [];
  const {eventDetail} = eportEventSchedule;
  const{start_date,end_date}=eventDetail

  if(date) {
    const inputDate=  validateDate(date);
    if(inputDate=="Invalid date"){
      errorsArray.push({message: langHook('schedulerInvalidDateErrorLabel', { '0': `${line},C` })});
    }
    else if(inputDate=="Invalid date format"){
       errorsArray.push({message: langHook('schedulerInvalidDateFormatErrorLabel', { '0': `${line},C` })});
    }
    else{
    if(!checkDateInEventDates(inputDate,start_date,end_date,time_zone)) {
       errorsArray.push({message: langHook('schedulerNoEventDateErrorLabel', { '0': `${line},C` })});
    }
  }
}
 return errorsArray;
  
}

export const checkTimeValidity = (langHook, startTime, endTime, line,time_zone,use_24_hour_format) => {
  const errorsArray = [];
  let newStartTime, newEndTime;
  if(startTime) {
     newStartTime= formatTime24and12Time(startTime,use_24_hour_format);

    if(newStartTime=="Invalid time format"){  
       errorsArray.push({message: langHook('schedulerInvalidStartTimeErrorLabel', { '0': `${line},D` })});  
    }
  }

  if(errorsArray.length<=0) {
  if(endTime) {
     newEndTime= formatTime24and12Time(endTime,use_24_hour_format);

    if(newEndTime=="Invalid time format"){
      errorsArray.push({message: langHook('schedulerInvalidEndTimeErrorLabel', { '0': `${line},E` })}); 
    }   
  }
}
 
if(startTime && endTime) {
   
    if(errorsArray.length<=0) {
     const isStartBeforeEnd = checkStartTimeBeforeEndTime(newStartTime, newEndTime, time_zone);
      if(!isStartBeforeEnd) {
         errorsArray.push({message: langHook('schedulerInvalidSessionTimeErrorLabel', { '0': `${line},D` })}); 
      }
    }
    
  
  }

  return errorsArray;
  
}


export const ValidateTeamNameWithNumber = (langHook, schedule, line,eportEventSchedule) => {
  const errorsArray = [];
  const {judgingSession,matchesSession} = eportEventSchedule;
  const teamName= schedule.teamName.trim().toLowerCase();
  const teamNumber= schedule.teamNumber.trim();
  const type=schedule.type.trim().toLowerCase();

    if(teamNumber) {

        if(type===JUDGE_SESSION.trim().toLowerCase()){

        if(!hasTeamNumberFind(judgingSession, teamNumber)){
          errorsArray.push({message: langHook('schedulerInvalidTeamNumberErrorLabel', { '0': `${line},G` })}); 
        }

      }
      else if(type.includes(MATCH)){
        if(!hasTeamNumberFind(matchesSession, teamNumber)){
          errorsArray.push({message: langHook('schedulerInvalidTeamNumberErrorLabel', { '0': `${line},G` })}); 
        }

      }
    }

  if(teamName)
  {
    if(errorsArray.length<=0) {
      if(type===JUDGE_SESSION.trim().toLowerCase()) {

        if(!hasTeamNameFind(judgingSession, teamName)){
          errorsArray.push({message: langHook('schedulerInvalidTeamNameErrorLabel', { '0': `${line},H` })}); 
        }

      }
      else if(type.includes(MATCH)){
        if(!hasTeamNameFind(matchesSession, teamName)){
          errorsArray.push({message: langHook('schedulerInvalidTeamNameErrorLabel', { '0': `${line},H` })}); 
        }

      }
    }
  }

  if(teamName && teamNumber)
  {
    if(errorsArray.length<=0) {
      if(type===JUDGE_SESSION.trim().toLowerCase()){

        if(!hasTeamNameAndNumberFind(judgingSession, teamName, teamNumber)){
          errorsArray.push({message: langHook('schedulerInvalidTeamNameNumberErrorLabel', { '0': `${line},H` })});
        }
      }
      else if(type.includes(MATCH)){
        if(!hasTeamNameAndNumberFind(matchesSession, teamName, teamNumber)){
           errorsArray.push({message: langHook('schedulerInvalidTeamNameNumberErrorLabel', { '0': `${line},H` })});
        }
      }
    }
  }
 
  return errorsArray;
  
}
